import React, { useEffect } from 'react';
import { Stack } from '@mui/material';
import { connect } from 'react-redux';
import { usersActions } from '../../modules/users/users.actions';
import Loader from './layout/loading/loader';
import ClientSelector from './patrimoine/ClientSelector';
import { isAdmin } from '../../utils/roles';
import PageTitle from './layout/PageTitle';
import { Map as MapIcon } from '@mui/icons-material';
import ConteneurMapView from './patrimoineV2/ConteneurMapView';

/**
 * Page Patrimoine v2 — POC vue cartographique des conteneurs.
 *
 * S'inspire de `PatrimoinePage` pour la sélection client/exploitant
 * (services type "lavage" uniquement) puis délègue le rendu à `ConteneurMapView`.
 */
function ConteneurMapPage({ dispatch, ...props }) {
    const [admin] = React.useState(isAdmin());
    const [clientSelected, setClientSelected] = React.useState(null);
    const [exploitantSelected, setExploitantSelected] = React.useState(
        window.localStorage.getItem('exploitantSelected')
    );
    const [exploitants, setExploitants] = React.useState([]);

    useEffect(() => {
        if (!props.clients && !props.loading && !props.error) {
            dispatch(usersActions.fetchClients());
        }

        if (props.clients && Array.isArray(props.clients)) {
            const uniqueExploitants = {};
            const extractedExploitants = [];

            const lavageClients = props.clients.filter(
                (c) => c.serviceTypes && c.serviceTypes.includes('lavage')
            );

            for (const client of lavageClients) {
                const exploitant = client.exploitant;
                if (exploitant && !uniqueExploitants[exploitant.id]) {
                    uniqueExploitants[exploitant.id] = true;
                    extractedExploitants.push(exploitant);
                }
            }
            setExploitants(extractedExploitants);

            const stored = window.localStorage.getItem('clientSelected');
            const clientIds = lavageClients.map((c) => c.id);
            if (!clientIds.includes(Number(stored))) {
                setClientSelected(null);
                window.localStorage.removeItem('clientSelected');
            } else {
                setClientSelected(stored);
            }
        }
    }, [dispatch, props.clients, props.error, props.loading]);

    const filteredClients = React.useMemo(() => {
        let data = [];
        if (admin) {
            if (exploitantSelected && Array.isArray(props.clients)) {
                for (const client of props.clients) {
                    if (
                        client.exploitant.id == exploitantSelected &&
                        client.serviceTypes && client.serviceTypes.includes('lavage')
                    ) {
                        data.push(client);
                    }
                }
            }
        } else {
            data = props.clients
                ? props.clients.filter(
                      (c) => c.serviceTypes && c.serviceTypes.includes('lavage')
                  )
                : [];
        }
        data?.sort((a, b) => a.libelle.localeCompare(b.libelle));
        return data;
    }, [admin, exploitantSelected, props.clients]);

    const onClientSelected = (clientId) => {
        window.localStorage.setItem('clientSelected', clientId);
        setClientSelected(clientId);
    };

    const onExploitantSelected = (exploitantId) => {
        window.localStorage.setItem('exploitantSelected', exploitantId);
        setExploitantSelected(exploitantId);
    };

    return (
        <>
            <Stack direction="row">
                <PageTitle title={'Patrimoine v2 — Carte conteneurs'} icon={<MapIcon />} />
            </Stack>

            <ClientSelector
                clients={filteredClients}
                isAdmin={admin}
                onClientSelected={onClientSelected}
                clientSelected={clientSelected}
                exploitants={exploitants}
                exploitantSelected={exploitantSelected}
                onExploitantSelected={onExploitantSelected}
            />

            {props.loading && <Loader />}

            {clientSelected && (
                <ConteneurMapView
                    key={clientSelected}
                    clientId={clientSelected}
                />
            )}
        </>
    );
}

const mapStateToProps = (state) => ({
    clients: state.users.clients,
    loading: state.users.loading,
    error: state.users.error,
});

export default connect(mapStateToProps)(ConteneurMapPage);
